import { resolveMediaUrl } from "./mediaUrl";

export const filePathToFile = async (relativeFilePath, fileName) => {
  const fullPath = resolveMediaUrl(relativeFilePath, { absolute: true, attachmentRoot: false });

  // Fetch the file content from the full file path (URL)
  const response = await fetch(fullPath);

  // Convert the response to a Blob
  const blob = await response.blob();

  // Create a File object from the Blob
  const file = new File([blob], fileName, { type: blob.type });

  return file;
};
